import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import styles from './SkeletonCard.module.css';

const SkeletonCard = ({
    size = "Small",
    initialOpen = false,
    rotation = 0
}) => {
    const [isOpen, setIsOpen] = useState(initialOpen);

    useEffect(() => {
        setIsOpen(initialOpen);
    }, [initialOpen]);

    const skeletonAnimation = {
        background: [
            "linear-gradient(90deg, #3F3F3C 0%, #3F3F3C 100%)",
            "linear-gradient(90deg, #535350 0%, #3F3F3C 100%)",
            "linear-gradient(90deg, #535350 100%, #535350 100%)",
            "linear-gradient(90deg, #3F3F3C 0%, #3F3F3C 100%)",
        ],
    };

    const skeletonTransition = {
        duration: 2,
        repeat: Infinity,
        ease: "easeInOut",
    };

    const springTransition = {
        type: "spring",
        stiffness: 500,
        damping: 60,
        mass: 1,
        delay: 0,
    };

    const cardClassName = `${styles.card} ${styles[size.toLowerCase()]} ${isOpen ? styles.open : styles.closed}`;

    return (
        <motion.div
            className={cardClassName}
            style={{
                backgroundColor: "#2B2B29",
                transform: `rotate(${rotation}deg)`,
            }}
            initial={false}
            animate={{
                width: isOpen
                    ? size === "Grande" ? 362.4 : 311.92
                    : size === "Grande" ? 180 : 154.28,
            }}
            transition={springTransition}
        >
            <motion.div
                className={styles.videoContainer}
                initial={false}
                animate={{
                    width: isOpen
                        ? size === "Grande" ? 342.4 : 295.92
                        : size === "Grande" ? 160 : 138.28,
                }}
                transition={springTransition}
            >
                <motion.div
                    className={styles.skeletonVideo}
                    animate={skeletonAnimation}
                    transition={skeletonTransition}
                />
            </motion.div>
            <div className={`${styles.mainContent} ${isOpen ? styles.open : styles.closed}`}>
                {isOpen ? (
                    <>
                        <motion.div
                            className={styles.logoContainer}
                            animate={skeletonAnimation}
                            transition={skeletonTransition}
                        />
                        <div className={styles.companyInfo}>
                            <motion.div
                                className={`${styles.skeletonText} ${styles.wide}`}
                                animate={skeletonAnimation}
                                transition={skeletonTransition}
                            />
                            <motion.div
                                className={`${styles.skeletonText} ${styles.narrow}`}
                                animate={skeletonAnimation}
                                transition={skeletonTransition}
                            />
                        </div>
                    </>
                ) : (
                    <div className={styles.companyInfo}>
                        <motion.div
                            className={`${styles.skeletonText} ${styles.centered}`}
                            animate={skeletonAnimation}
                            transition={skeletonTransition}
                        />
                    </div>
                )}
            </div>
        </motion.div>
    );
};

export default SkeletonCard;